<template>
    <div :class="`phone_input_wrapper ${errorMessage ? 'failed' : ''}`">
        <div class="phone_input">
            <input 
              v-model="maskedValue"
              v-maska="bindedObject"
              :data-maska="mask"
              :placeholder="text('phone_input.phone')"
              inputmode="numeric"
              autofocus
              @maska="$emit('update:phone', country['code'] + bindedObject['unmasked'])"
            >
            <button class="phone_input_button" @click="openCountrySelect()">
                <span class="flag">{{country['flag']}}</span>
                <span class="code">{{country['code']}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path d="M4.5 6L8.5 10L12.5 6" stroke="#090A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
        <div id="country-options" :class="`countries_wrapper ${countriesListOpened ? 'active': ''}`">
            <input type="search" placeholder="Search country" v-model="search_input" ref="country_search_input" class="country_search">
            <div class="countries">
                <button @click="selectCountry(item)" v-for="(item, idx) in filteredCountriesList" :key="idx" :class="item['name'] === country['name'] ? 'active' : ''">
                    <span class="flag">{{item['flag']}}</span>
                    <span>{{ item['name'] }}</span>
                </button>
            </div>
        </div>
        <div v-if="select_mask" class="select_mask">
            <button @click="selectedMask(item)" v-for="(item, idx) in multiple_mask" :key="idx">
                {{country['code']}} {{item}}
            </button>
        </div>
        <div class="error-label">{{ errorMessage }}</div>
    </div>
</template>

<script>
import { allCountries } from '@/data/countries.js'
import { vMaska } from "maska";

export default {
    props: {
      phone: String,
      errorMessage: {
        type: String,
        default: ''
      }
    },
    emits: ["update:phone"],
    directives: { maska: vMaska },
    data () {
        return {
            maskedValue: '',
            bindedObject: {
                masked: "",
                unmasked: "",
                completed: false,
            },
            country: null,
            mask: "(###)###-####",
            multiple_mask: [],
            select_mask: false,
            country_select: false,
            search_input: '',
            countriesListOpened: false,
        }
    },
    computed: {
      filteredCountriesList({ search_input, allowedCountries }) {
        if (!search_input) {
          return allowedCountries
        } else {
          return allowedCountries.filter(item => {
            return item['name'].toUpperCase().includes(this.search_input.toUpperCase())
          })
        }
      },
      allowedCountries() {
        if (this.envName === 'grok' ) {
          return allCountries.filter(({ name }) => name !== 'Russia')
        } else {
          return allCountries
        }
      }
    },
    created () {
      this.setDefaultCountry()
    },
    methods: {
        setDefaultCountry() {
          const browserCountryIso = this.getBrowserCountryIso()
          const defaultCountry = this.allowedCountries.find(({ iso }) => iso === browserCountryIso)
            || this.allowedCountries[0]

          if (defaultCountry) {
            this.applyCountry(defaultCountry)
          }
        },
        getBrowserCountryIso() {
          if (typeof navigator === 'undefined') {
            return ''
          }

          const locales = [
            ...(Array.isArray(navigator.languages) ? navigator.languages : []),
            navigator.language,
          ].filter(Boolean)

          const localeWithRegion = locales.find((locale) => {
            const parts = String(locale).replace('_', '-').split('-')
            return parts.length > 1 && parts[1]
          })

          if (!localeWithRegion) {
            return ''
          }

          return String(localeWithRegion).replace('_', '-').split('-')[1].toUpperCase()
        },
        applyCountry(item) {
            this.country = item;
            if (Array.isArray(item['mask'])) {
                this.multiple_mask = [...item['mask']]
                this.mask = this.multiple_mask[0]
                this.select_mask = false;
            } else {
                this.mask = item['mask'];
                this.multiple_mask = []
                this.select_mask = false;
            }
        },
        checkClickOutside (event) {
          const myDiv = document.getElementById('country-options');

          if (!myDiv) {
            return;
          }

          if (!myDiv.contains(event.target)) {
            this.killOutsideListener()
          }
        },
        addOutsideListener() {
          document.addEventListener('click', this.checkClickOutside);
        },
        killOutsideListener() {
          this.countriesListOpened = false;
          setTimeout(() => {
            document.removeEventListener('click', this.checkClickOutside);
          }, 0)
        },
        openCountrySelect () {
            this.countriesListOpened = true;
            this.$refs.country_search_input.focus();

            setTimeout(() => {
              this.addOutsideListener()
            }, 0)
        },
        selectCountry (item) {
            this.applyCountry(item);
            if (Array.isArray(item['mask'])) {
                this.multiple_mask = []
                this.multiple_mask = [...item['mask']]
                this.select_mask = true;
            }
            this.killOutsideListener();
            this.search_input = "";
            this.maskedValue = "";
        },
        selectedMask (item) {
            this.mask = item;
            this.select_mask = false;
        },
    }
}
</script>

<style lang="scss">
  .phone_input_wrapper {
    .error-label {
      display: none;
    }
    &.failed {
      .phone_input {
        border: 1px solid red;
      }
      .error-label {
        display: block;
        margin-top: 4px;
        color: red;
        font-size: 12px;
      }
    }
  }
</style>
